// extracted by mini-css-extract-plugin
module.exports = {"forceNoPadding":"FilterableHeaderTable_forceNoPadding__2M8op","titlePadding":"FilterableHeaderTable_titlePadding__FXYDg"};